var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterslogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.2 17.9",
    style: {
      enableBackground: "new 0 0 95.2 17.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,7.3L13.3,7.3L9.6,17.4H8.5L5.1,7.3h0l-1.4,9.9H0.5L3.2,0.8h2.2l3.9,10.5L13,0.8h2.2l2.4,16.3h-3.1 L13.3,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,17.6c-4.9,0-7.9-3.7-7.9-8.4c0-4.7,3.1-8.4,7.9-8.4c4.7,0,7.9,3.6,7.9,8.4C34,13.9,31,17.6,26.1,17.6z  M26.1,3.9c-2.9,0-4.7,2.6-4.7,5.2c0,2.4,1.2,5.5,4.7,5.5c3.4,0,4.7-3,4.7-5.5C30.8,6.5,29.1,3.9,26.1,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,1.3h3.1v8.9c0,2,0.2,4.7,2.8,4.7c2.6,0,2.8-2.8,2.8-4.7V1.3h3.1v9.5c0,3.9-1.6,6.8-5.9,6.8 c-4.3,0-5.9-2.9-5.9-6.8V1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,0.8h2.2L60.1,12h0V1.3h3.1v16.2H61L52.6,6.4h0v10.8h-3.1V0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.6,17.2h-3.1V4h-3.2V1.3h9.5V4h-3.2V17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,9.2v2.4H73V9.2H78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.4,17.9l-1.1-1.3c-1.1,0.7-2.5,1.1-3.9,1.1c-4.6,0-7.9-3.8-7.9-8.4c0-4.5,3.2-8.4,7.9-8.4s7.9,3.9,7.9,8.4 c0,2.2-0.7,4.2-1.9,5.8l2.2,2.6L92.4,17.9z M91,12.4c0.7-0.9,1-2.2,1-3.3c0-2.6-1.9-5.3-4.7-5.3c-3,0-4.7,2.8-4.7,5.6 c0,2.6,1.6,5.2,4.7,5.2c0.6,0,1.2-0.3,1.7-0.5l-2.6-3l3.2-0.3L91,12.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterslogoWhite);
export default __webpack_public_path__ + "static/media/letterslogo_white.11f556cf341f7b87f876a30c13d55b34.svg";
export { ForwardRef as ReactComponent };